module.exports = __webpack_public_path__ + "static/media/business-background.e5816021.png";